import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoginService } from './data/login.service';
import { IfAuthorizedDirective } from './directives/if-authorized.directive';
import { IfUserRoleDirective } from './directives/if-user-role.directive';

// import { LoginService } from './data/login.service';
// import { LoginFormComponent } from './login-form/login-form.component';
// import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        NgbAlertModule
    ],
    declarations: [
        LoginFormComponent,
        IfAuthorizedDirective,
        IfUserRoleDirective
    ],
    providers: [
        LoginService
    ],
    bootstrap: [],
    exports: [
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        NgbAlertModule,
        MatProgressSpinnerModule,
        LoginFormComponent,
        IfAuthorizedDirective,
        IfUserRoleDirective
    ]
})
export class LoginModule { }
